import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../../components/table/TableOps'
import { DialogTitle, Dialog, DialogContent, DialogActions, Button, FormControl, Select, MenuItem, InputLabel, TextField } from '@material-ui/core';
import Http from '../../../Http';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ACCESS from '../../../ACCESS';

class Recepciones extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'preguia/recepciones', deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Preguías recoleccionadas', [
        { label: 'Preguía', id: 'id' },
        { label: 'Fecha de recolección', id: 'pg_pro_fecha' },
        { label: 'Fecha de preguía', id: 'pg_fecha_reporte' },
        { label: 'Cliente', id: 'cliente' },
        { label: 'Nombre', id: 'cliente_rsocial' },
        { label: 'Transportista', id: 'transportista_nombre' },
      ], [
        { id: 'asignar', icon: 'assignment', access: [ACCESS.PREGUIA.ASIGNAR_A_TRASNPORTISTA] },
      ]))
    this.table();
    this.loadTransportistas();
  }

  loadTransportistas = async () => {
    console.log('TRes')
    let TRes = await Http.get('unidad-transporte/all');
    if (!TRes.error) {
      this.setState({ transportistas: TRes.data })
    }
  }

  action = (id, row) => {
    if (id === 'asignar') {
      this.setState({ tdOpen: true, tdRow: row, id_unidad_transporte: row.id_unidad_transporte })
    }
  }

  marcarRecibido = async () => {
    var { id_unidad_transporte, tdRow, pg_destinos, pg_recep_fecha } = this.state;
    pg_recep_fecha = pg_recep_fecha ? pg_recep_fecha : new Date();
    pg_destinos = pg_destinos ? pg_destinos : 1;
    if (!id_unidad_transporte) return this.setState({ tdOpen: false })
    console.log(pg_recep_fecha, tdRow)
    let Res = await Http.post('preguia/recibida', { id: tdRow.id, id_unidad_transporte, pg_destinos, pg_recep_fecha, pg_estado: 7, pg_destinos_rest: pg_destinos });
    if (!Res.error) {
      this.setState({ tdOpen: false });
      this.table();
    }
  }

  render() {
    var { pg_recep_fecha, transportistas, id_unidad_transporte, pg_destinos, tdOpen } = this.state;
    transportistas = transportistas ? transportistas : []
    pg_recep_fecha = pg_recep_fecha ? pg_recep_fecha : new Date()
    return (
      <div>
        <div>
          <this.TableRender />
        </div>

        <div>
          <Dialog onClose={() => { this.setState({ tdOpen: false }) }} open={tdOpen ? tdOpen : false}>
            <DialogTitle onClose={() => { this.setState({ tdOpen: false }) }}>
              Recibida
            </DialogTitle>
            <DialogContent dividers>
              <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel>
                    Transportista
                </InputLabel>
                  <Select
                    value={id_unidad_transporte ? id_unidad_transporte : ''}
                    onChange={(e) => this.setState({ id_unidad_transporte: e.target.value })}
                  >
                    {transportistas.map((tra, i) => (
                      <MenuItem key={i} value={tra.id}>{tra.unidad} - {tra.transportista_nombre} </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <FormControl className='form-field'>
                    <KeyboardDateTimePicker
                      inputVariant="outlined"
                      variant="inline"
                      ampm={false}
                      value={pg_recep_fecha}
                      format="dd/MM/yyyy HH:mm"
                      disablePast
                      onChange={(e) => { this.setState({ pg_recep_fecha: e }) }} />
                  </FormControl>
                </MuiPickersUtilsProvider>
              </div>
              <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                <TextField fullWidth type='number' label='Número de destinos' variant='outlined' value={pg_destinos ? pg_destinos : 1} onChange={(e) => this.setState({ pg_destinos: e.target.value })} />
              </div>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={() => { this.marcarRecibido() }} color="primary">
                Recibido
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    )
  }
}

export default withRouter(Recepciones)
